import { render } from "./NeoFaqs.vue?vue&type=template&id=1d733096"
import script from "./NeoFaqs.vue?vue&type=script&lang=js"
export * from "./NeoFaqs.vue?vue&type=script&lang=js"

import "./NeoFaqs.vue?vue&type=style&index=0&id=1d733096&lang=scss"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__